import { render } from "./UpdateDatabase.vue?vue&type=template&id=d328ca0e&scoped=true"
import script from "./UpdateDatabase.vue?vue&type=script&lang=js"
export * from "./UpdateDatabase.vue?vue&type=script&lang=js"

import "./UpdateDatabase.vue?vue&type=style&index=0&id=d328ca0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d328ca0e"]])

export default __exports__